import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import './Professionalinfo.css';

function AgencyElectricianFields({ formData, updateField }) {
    const toggleSingleField = (field, value) => {
        const newValue = formData[field] === value ? null : value;
        updateField(field, newValue);
    };

    const toggleArrayField = (field, item) => {
        const currentArray = formData[field] || [];
        const safeArray = Array.isArray(currentArray) ? currentArray : [currentArray];

        const updated = safeArray.includes(item)
            ? safeArray.filter(i => i !== item)
            : [...safeArray, item];
        updateField(field, updated);
    };

    // Industry Options
    const industries = [
        "Manufacturing", "Oil & Gas", "Petrochemical",
        "Power Plant", "Construction", "Facility Maintenance"
    ];

    // Technical Skills
    const electricalExperienceOptions = [
        "Industrial Panel Wiring", "Control Panel Assembly", "Cable Laying & Glanding",
        "Motor Installation", "Motor Rewinding", "Transformer Maintenance",
        "Switchgear Installation", "Circuit Breaker Maintenance"
    ];

    const automationControlsOptions = [
        "PLC Basic Knowledge", "VFD Installation", "SCADA Basic",
        "Sensor Installation", "Troubleshooting Control Circuits"
    ];

    const drawingTestingOptions = [
        "read Electrical Drawings", "Single Line Diagram", "Load Calculation",
        "Use of Multimeter", "Use of Megger", "Testing & Commissioning"
    ];

    // Voltage Experience
    const voltageExperienceOptions = [
        "Low Voltage (LV)", "Medium Voltage (MV)", "High Voltage (HV)"
    ];

    // Maximum Voltage
    const maxVoltageOptions = [
        "Up to 415V (LV)", "Up to 11kV (MV)", "Up to 33kV (HV)", "Above 33kV (EHV)"
    ];

    // Electrical License
    const electricalLicenseOptions = [
        "Wireman License", "Supervisor License", "Gulf Electrical License"
    ];

    return (
        <>
            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Industry Type</h4>
                <Row className="g-3 mb-3">
                    {industries.map((industry, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.electrician_industry_type === industry ? 'selected-button' : ''}`}
                                onClick={() => {
                                    if (formData.electrician_industry_type === industry) {
                                        updateField('electrician_industry_type', null);
                                    } else {
                                        updateField('electrician_industry_type', industry);
                                        updateField('other_electrician_industry', '');
                                    }
                                }}
                            >
                                {industry}
                            </Button>
                        </Col>
                    ))}
                    <Col xs={12}>
                        <Form.Control
                            type="text"
                            placeholder="Other (Type here)"
                            className="jobtype-btn w-100 h-100 text-center"
                            style={{
                                backgroundColor: formData.electrician_industry_type === 'Other' ? '#0d6efd' : '#f8f9fa',
                                color: formData.electrician_industry_type === 'Other' ? 'white' : 'black',
                                border: 'none'
                            }}
                            value={formData.other_electrician_industry || ''}
                            onChange={(e) => {
                                updateField('electrician_industry_type', 'Other');
                                updateField('other_electrician_industry', e.target.value);
                            }}
                            onClick={() => {
                                if (formData.electrician_industry_type !== 'Other') {
                                    updateField('electrician_industry_type', 'Other');
                                }
                            }}
                        />
                    </Col>
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Technical Skills</h4>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Electrical Work Experience:</h6>
                <Row className="g-3 mb-4">
                    {electricalExperienceOptions.map((exp, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.electrical_experience?.includes(exp) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('electrical_experience', exp)}
                            >
                                {exp}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Automation & Controls:</h6>
                <Row className="g-3 mb-4">
                    {automationControlsOptions.map((opt, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.automation_controls?.includes(opt) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('automation_controls', opt)}
                            >
                                {opt}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Drawing & Testing:</h6>
                <Row className="g-3 mb-4">
                    {drawingTestingOptions.map((opt, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.drawing_testing?.includes(opt) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('drawing_testing', opt)}
                            >
                                {opt}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Voltage Experience:</h6>
                <Row className="g-3 mb-4">
                    {voltageExperienceOptions.map((opt, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.voltage_experience?.includes(opt) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('voltage_experience', opt)}
                            >
                                {opt}
                            </Button>
                        </Col>
                    ))}
                </Row>

                <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Maximum voltage worked on:</h6>
                <Row className="g-3 mb-4">
                    {maxVoltageOptions.map((opt, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.max_voltage === opt ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('max_voltage', opt)}
                            >
                                {opt}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3" style={{ color: "black" }}>Certification</h4>

                <Row className="g-4">
                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>ITI / Diploma in Electrical:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.iti_diploma_electrical === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('iti_diploma_electrical', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.iti_diploma_electrical === 'No' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('iti_diploma_electrical', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Electrical License (if any):</h6>
                        <Row className="g-3 mb-3">
                            {electricalLicenseOptions.map((opt, idx) => (
                                <Col xs={6} sm={4} key={idx}>
                                    <Button
                                        variant="light"
                                        className={`language-btn jobtype-btn w-100 h-100 ${formData.electrical_license === opt ? 'selected-button' : ''}`}
                                        onClick={() => {
                                            if (formData.electrical_license === opt) {
                                                updateField('electrical_license', null);
                                            } else {
                                                updateField('electrical_license', opt);
                                                updateField('other_electrical_license', '');
                                            }
                                        }}
                                    >
                                        {opt}
                                    </Button>
                                </Col>
                            ))}
                            <Col xs={12} sm={12}>
                                <Form.Control
                                    type="text"
                                    placeholder="Other / Type your license here"
                                    className="jobtype-btn w-100 text-center"
                                    style={{
                                        backgroundColor: formData.electrical_license === 'Other' ? '#0d6efd' : '#f8f9fa',
                                        color: formData.electrical_license === 'Other' ? 'white' : 'black',
                                        border: 'none',
                                        height: '60px'
                                    }}
                                    value={formData.other_electrical_license || ''}
                                    onChange={(e) => {
                                        updateField('electrical_license', 'Other');
                                        updateField('other_electrical_license', e.target.value);
                                    }}
                                    onClick={() => {
                                        if (formData.electrical_license !== 'Other') {
                                            updateField('electrical_license', 'Other');
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Trade Test Passed Before:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.electrical_trade_test_passed === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('electrical_trade_test_passed', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.electrical_trade_test_passed === 'No' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('electrical_trade_test_passed', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>

                    <Col md={12}>
                        <h6 className="mb-3" style={{ color: "black", fontWeight: 'bold' }}>Ready for Trade Test:</h6>
                        <div className="d-flex gap-3">
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.electrical_ready_for_test === 'Yes' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('electrical_ready_for_test', 'Yes')}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn flex-grow-1 ${formData.electrical_ready_for_test === 'No' ? 'selected-button' : ''}`}
                                onClick={() => toggleSingleField('electrical_ready_for_test', 'No')}
                            >
                                No
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default AgencyElectricianFields;
